import React from 'react';

import { Urls } from 'js/src/client';
import { BUTTON_SIZES, SecondaryButton } from 'js/src/components/common/ui/Button';
import Callout from 'js/src/components/common/ui/Callout';
import { trackUpsellClicked } from 'js/src/libs/analytics-utils';

export const UpgradeToRemoveCreditSceneCallout = React.memo(
    function UpgradeToRemoveCreditSceneCallout() {
        const onUpsellClicked = React.useCallback(() => {
            const context = 'remove_lumen5_branding_prompt';
            trackUpsellClicked(context);
            window.open(Urls.PRICING, '_blank');
        }, []);

        return (
            <div className="upgrade-to-remove-credit-scene-callout">
                <Callout>
                    <div className="d-flex align-items-center">
                        <div>
                            <p className="mb-l5-0">
                                <strong>Upgrade</strong> to remove Lumen5 branding.
                            </p>
                        </div>
                        <SecondaryButton
                            text="Upgrade"
                            className="ms-l5-auto flex-shrink-0"
                            onClick={onUpsellClicked}
                            size={BUTTON_SIZES.MD}
                        />
                    </div>
                </Callout>
            </div>
        );
    },
);
